import * as React from 'react';
export const OnSelectOrderContext = React.createContext(null);
export const OnSelectOrderContextProvider = OnSelectOrderContext.Provider;
